/*
 *
 * Package: `@dbh/pdp-page`.
 *
 */const importPdpPage=()=>import('./component-60eb48b7.js'/*  webpackChunkName: 'dbh.pdp-page.component' */);// to avoid the exported code leaking into other pages and increasing the bundle
// size unappropriately.

export { importPdpPage as default };
